import axios from 'axios'

const apiUrl = process.env.VUE_APP_API_URL

if (!apiUrl) {
  throw new Error('VUE_APP_API_URL is not defined')
}

const http = axios.create({
  baseURL: apiUrl
})

const token = localStorage.getItem('level_token')
if (token) {
  http.defaults.headers.common.Authorization = `Bearer ${token}`
}

export default http
